import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { cn } from '@/lib/utils';
import { MindfullMark } from './MindfullMark';

/**
 * Waiting for Mindfull to start (sign-in, profile, the first board): the
 * mark alone on paper, its notes bobbing in the pocket (the mark's loop).
 * Same size and place as index.html's #boot-splash, so the hand-over from the
 * page's first paint to the app is seamless. It fades in a beat late, so a
 * quick start never flashes it.
 */
export function LaunchLoader({ label = 'Loading', fill = 'screen', className }: { label?: string; fill?: 'screen' | 'parent'; className?: string }) {
  const reduce = useReducedMotion() ?? false;
  return (
    <div
      role="status"
      aria-label={label}
      className={cn('flex items-center justify-center bg-paper text-ink', fill === 'screen' ? 'fixed inset-0 z-[60]' : 'h-full w-full', className)}
    >
      <motion.div
        initial={reduce ? { opacity: 1 } : { opacity: 0, scale: 0.96 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={reduce ? { duration: 0 } : { type: 'spring', stiffness: 500, damping: 38, delay: 0.12 }}
      >
        <MindfullMark size={52} motion={reduce ? 'still' : 'loop'} />
      </motion.div>
    </div>
  );
}
